(function () {
  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.kiki-hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kiki-dot]'));
    var dotsWrap = root.querySelector('.kiki-hero__dots');
    if (slides.length < 2) return;

    var host = root.closest('[data-kiki-home]');
    var intervalMs = 6000;
    if (host) {
      var raw = parseInt(host.getAttribute('data-slide-interval'), 10);
      if (!isNaN(raw) && raw > 0) intervalMs = raw;
    }

    var current = 0;
    var timer = null;
    var wheelLockUntil = 0;
    var pointerStartX = null;
    var pointerStartY = null;

    function alignDotsToButton() {
      if (!dotsWrap) return;
      var activeSlide = slides[current];
      if (!activeSlide) return;

      var cta = activeSlide.querySelector('.kiki-hero__actions .kiki-btn--gold');
      if (!cta) {
        dotsWrap.style.left = '';
        dotsWrap.style.transform = '';
        return;
      }

      var rootRect = root.getBoundingClientRect();
      var ctaRect = cta.getBoundingClientRect();
      var ctaCenter = ctaRect.left - rootRect.left + ctaRect.width / 2;
      dotsWrap.style.left = ctaCenter + 'px';
      dotsWrap.style.transform = 'translateX(-50%)';
    }

    function setActive(nextIndex) {
      current = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === current);
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
      alignDotsToButton();
    }

    function start() {
      stop();
      timer = window.setInterval(function () {
        setActive(current + 1);
      }, intervalMs);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setActive(index);
        start();
      });
    });

    root.addEventListener(
      'wheel',
      function (event) {
        var now = Date.now();
        if (now < wheelLockUntil) return;

        var delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (Math.abs(delta) < 24) return;

        event.preventDefault();
        wheelLockUntil = now + 450;
        setActive(delta > 0 ? current + 1 : current - 1);
        start();
      },
      { passive: false }
    );

    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });

    root.addEventListener('pointerup', function (event) {
      if (pointerStartX === null || pointerStartY === null) return;
      var dx = event.clientX - pointerStartX;
      var dy = event.clientY - pointerStartY;

      pointerStartX = null;
      pointerStartY = null;

      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
      setActive(dx < 0 ? current + 1 : current - 1);
      start();
    });

    root.addEventListener('pointercancel', function () {
      pointerStartX = null;
      pointerStartY = null;
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    window.addEventListener('resize', alignDotsToButton);

    setActive(0);
    start();
  }

  function initReveal() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('[data-kiki-reveal]'));
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-kiki-carousel]')).forEach(initCarousel);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
